import { Injectable } from '@angular/core';
import { toJsonString } from '@util';
import * as R from 'ramda';

@Injectable()
export class LocalStorageService {
  write(key: string, value: any) {
    const jsonValue = toJsonString(value);
    localStorage.setItem(key, jsonValue);
  }

  read<T>(key: string): T {
    const value: string = localStorage.getItem(key);

    try {
      return value && JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  remove(...keys: string[]) {
    R.forEach((key: string) =>
      localStorage.removeItem(key),
    keys
    );
  }
}

